<mat-accordion>
  @let personalLayersState = personalLayersState$();
  <mat-expansion-panel
    [expanded]="personalExpanded$()"
    [disabled]="personalLayersState.status === 'loading'"
    (opened)="onPanelOpened()"
    (closed)="onPanelClosed()"
  >
    <mat-expansion-panel-header>
      <mat-panel-title class="layers-panel-title"> Personal layers </mat-panel-title>
      <mat-panel-description class="expansion-panel-loader">
        @if (personalLayersState.status === 'loading') {
          <mat-spinner diameter="20"></mat-spinner>
        } @else {
          <button
            mat-icon-button
            [matMenuTriggerFor]="sortMenu"
            matTooltip="Sort"
            (click)="$event.stopPropagation()"
          >
            <mat-icon>swap_vert</mat-icon>
          </button>
          <mat-menu #sortMenu="matMenu">
            <button
              mat-menu-item
              [disabled]="sortSelected$() === 'name'"
              (click)="filterPersonalLayer('name')"
            >
              <mat-icon>sort_by_alpha</mat-icon>
              Name
            </button>
            <button
              mat-menu-item
              [disabled]="sortSelected$() === 'oldToNew'"
              (click)="filterPersonalLayer('oldToNew')"
            >
              <mat-icon>date_range</mat-icon>
              Old to new
            </button>
            <button
              mat-menu-item
              [disabled]="sortSelected$() === 'newToOld'"
              (click)="filterPersonalLayer('newToOld')"
            >
              <mat-icon>event_repeat</mat-icon>
              New to old
            </button>
          </mat-menu>

          <!-- ! tooltip must be outside because button disabled hide tooltip -->
          @let spaceState = stillSpaceOnAccountState$();
          <span
            [matTooltip]="
              spaceState.status !== 'success'
                ? 'You cannot add a personal layer right now. Try again later.'
                : spaceState.data
                  ? 'Add a personal layer'
                  : 'Your account is already full. Delete data to add new layers.'
            "
          >
            <button
              matIconButton
              aria-label="Add a personal layer"
              [disabled]="spaceState.status !== 'success' || !spaceState.data"
              (click)="addPersonalLayer($event)"
            >
              <mat-icon>note_add</mat-icon>
            </button>
          </span>
        }
      </mat-panel-description>
    </mat-expansion-panel-header>
    @switch (personalLayersState.status) {
      @case ('loading') {
        <!-- nothing, loader in header -->
      }
      @case ('error') {
        <span class="no-data">
          Personal layers not available<br />
          Please, try again later.
        </span>
      }
      @case ('success') {
        <div class="layers-list">
          @if (filteredPersonalLayers$().length > 0) {
            @for (layer of filteredPersonalLayers$(); track layer.id) {
              <app-card-layer-personal [layer]="layer"></app-card-layer-personal>
            }
          } @else {
            No personal layers uploaded.
          }
        </div>
      }
    }
  </mat-expansion-panel>
</mat-accordion>
